import { createAsyncThunk } from '@reduxjs/toolkit';
import { setTimelineAsDeletedService } from 'scenes/Timelines/services/setTimelineAsDeleted.service';

import { selectSelectedTimeline } from '../selectors/timelineSelectors';

export const setTimelineAsDeleted = createAsyncThunk(
  'timelines/setTimelineAsDeleted',
  async (timelineId, { getState, rejectWithValue }) => {
    const state = getState();

    const selectedTimeline = selectSelectedTimeline(state);
    try {
      const response = await setTimelineAsDeletedService(
        selectedTimeline.projectId,
        timelineId
      );
      return response;
    } catch (error) {
      console.error('Failed to update timeline:', error);
      return rejectWithValue(error.response.data);
    }
  }
);
